import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersToSpark, getDailySparks, sendSparks } from "../../../store/Spark/SparkThunks";
import SparkSvg from "../../../../../assets/Spark.svg";
import SparkNotUsed from "../../../../../assets/SparkNotUsed.svg";
import SparkArrow from "../../../../../assets/SparkArrow.svg";

import { useTranslation } from "react-i18next";
import "./SendSparks.css"
import { Button } from "@mui/material";

export default function SendSparks({ onClose }) {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { localAvatar } = useSelector(state => state.auth);
    const { DailySparks, SparkUsers } = useSelector(state => state.Spark);
    const [selectedSparkReceiver, setSelectedSparkReceiver] = useState(null);
    const [selectedModal, setSelectedModal] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedSparkCount, setSelectedSparkCount] = useState(0);
    const [sparkMessage, setSparkMessage] = useState("");
    const [mySparkData, setMySparkData] = useState(null);


    useEffect(() => {
        dispatch(getDailySparks({ params: [{ user_id: localAvatar.id }] }));
        dispatch(getAllUsersToSpark({ params: [{ userSparkId: localAvatar.id }] }));
        setSelectedModal("selectUser");
    }, []);


    useEffect(() => {
        const usersArray = SparkUsers?.result;

        if (!usersArray || !Array.isArray(usersArray)) return;

        const myData = usersArray.find(user => user.id === localAvatar.id);

        if (myData) {
            setMySparkData(myData);
        }
    }, [SparkUsers, localAvatar.id]);

    const filteredUsers = useMemo(() => {
        const usersArray = SparkUsers?.result;

        if (!usersArray || !Array.isArray(usersArray)) return [];

        const term = searchTerm.toLowerCase().trim();

        let filtered = usersArray
            .filter(user => user.id !== localAvatar.id)
            .filter(user => {
                if (!term) return true;
                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
                return fullName.includes(term);
            });

        filtered.sort((a, b) => {
            if (a.isConnected !== b.isConnected) {
                return a.isConnected ? -1 : 1;
            }

            const nameA = a.firstName?.toLowerCase() || "";
            const nameB = b.firstName?.toLowerCase() || "";
            return nameA.localeCompare(nameB);
        });

        return filtered;
    }, [SparkUsers, searchTerm, localAvatar.id]);

    const maxSparksToSend = useMemo(() => {
        if (!selectedSparkReceiver) return 0;
        return Math.min(
            5,
            DailySparks,
            selectedSparkReceiver.sparks_remaining
        );
    }, [DailySparks, selectedSparkReceiver]);

    useEffect(() => {
        setSelectedSparkCount(0);
        setSparkMessage("");
    }, [selectedSparkReceiver]);

    const returnToSelectReceiver = async () => {
        setSelectedSparkCount(0);
        setSparkMessage("");
        setSearchTerm("");
        try {
            await Promise.all([
                dispatch(getDailySparks({ params: [{ user_id: localAvatar.id }] })),
                dispatch(getAllUsersToSpark({ params: [{ userSparkId: localAvatar.id }] }))
            ]);
            setSelectedModal("selectUser");
        } catch (error) {
            console.error("❌ Error refreshing spark data:", error);
            setSelectedModal("selectUser");
        }
        setSelectedModal("selectUser");
    };
    const handleSparkClick = (index) => {
        setSelectedSparkCount(index + 1);
    };

    const cancel = () => {
        setSelectedSparkCount(0);
        setSparkMessage("");
        setSearchTerm("");
        onClose();
    };

    const getInitials = (firstName, lastName) => {
        if (!firstName) return "?";
        const first = firstName.charAt(0).toUpperCase();
        const last = lastName ? lastName.charAt(0).toUpperCase() : "";
        return `${first}${last}`.trim() || first;
    };
    const sendSparksToUser = () => {
        if (!selectedSparkReceiver || selectedSparkCount === 0) return;
        const bodyData = {
            sender_spark_id: mySparkData?.userSparkId,
            receiver_spark_id: selectedSparkReceiver.userSparkId,
            amount: selectedSparkCount,
            ...(sparkMessage.trim() && { message: sparkMessage.trim() })
        };

        dispatch(sendSparks({ body: bodyData }))
            .then((response) => {
                setSelectedModal("SparkSent");
                dispatch(getDailySparks({ params: [{ user_id: localAvatar.id }] }));
            })
            .catch((error) => {
                console.error("❌ Error sending sparks:", error);
            });
    };
    return (
        <>
            <div className="Spark-Modal" onClick={cancel}>
                <div className="Spark-modal-centered" onClick={(e) => e.stopPropagation()}>
                    <div className="Spark-Modal-Step-header">
                        <span className="Spark-Modal-Step-header-icon"
                            style={{ backgroundColor: "#449930" }}></span>
                        <span className="Spark-Modal-Step-header-icon"
                            style={{
                                backgroundColor: selectedModal === "selectUser" ? "#D9D9D9" : "#449930"
                            }}></span>
                        <span className="Spark-Modal-Step-header-icon"
                            style={{
                                backgroundColor: selectedModal === "SparkSent" ? "#449930" : "#D9D9D9"
                            }}>
                        </span>
                    </div>
                    {selectedModal === "selectUser" &&
                        <>
                            <div className="Spark-Modal-header">
                                <div className="Spark-Modal-header-left">
                                    <span className="material-symbols-outlined Spark-person">
                                        person
                                    </span>
                                    <div className="Spark-Modal-header-title">
                                        <span className="Spark-Modal-header-title-text">
                                            {t("select_user")}
                                        </span>
                                        <span className="Spark-modal-header-subtitle">
                                            {t("select_user_give")}
                                        </span>
                                    </div>
                                    <div className="Spark-modal-header-right">
                                        <Button className="close-button" onClick={cancel}
                                            style={{ padding: "0", margin: "0", maxWidth: "30px", width: "30px", minWidth: "20px" }}>
                                            <span className="material-symbols-outlined">close</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="Select-Spark-modal-content" >
                                <div className="Spark-Modal-search-container">
                                    <input
                                        type="text"
                                        placeholder={t('search_participant')}
                                        className="Spark-Modal-search-input-conference"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            </div>
                                <div className="Spark-modal-users">
                                    {filteredUsers.map((user) => {
                                        // 1. Vérifier si l'utilisateur n'a plus de sparks disponibles à recevoir
                                        const isDisabled = user.sparks_remaining === 0;

                                        return (
                                            <div key={user.id}
                                                className={`user-spark-card ${selectedSparkReceiver?.id === user.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                                onClick={() => {
                                                    if (isDisabled) return;

                                                    setSelectedSparkReceiver(user);
                                                    setSelectedModal("sendSpark");
                                                }}
                                            >
                                                <div className="user-spark-card-content">
                                                    <div className="user-spark-card-avatar">
                                                        <span className="user-spark-name">
                                                            {user.firstName} {user.lastName}
                                                        </span>
                                                        <span className="user-spark-connected"
                                                            style={{
                                                                backgroundColor: user.isConnected ? "#22C55E" : "#D92D20"
                                                            }}>
                                                        </span>
                                                    </div>
                                                    <div className="user-spark-card-info">
                                                        <span className="user-spark-room">
                                                            {user.room_label}
                                                        </span>
                                                        {selectedSparkReceiver?.id === user.id && (
                                                            <span className="material-symbols-outlined user-spark-selected">
                                                                check_circle
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        );
                                    })}
                                </div>
                                {/*
  <div className="Spark-modal-button-container">
                                <button type="button" className="Spark-modal-button-send-sparks" style={{ width: "100%" }} onClick={() => { if (selectedSparkReceiver !== null) setSelectedModal("sendSpark") }}>
                                    {t("continue")}
                                </button>
                            </div>
 */}
                            </div>

                        </>

                    }



                    {selectedModal === "sendSpark" && selectedSparkReceiver !== null &&
                        <>
                            <div className="Spark-Modal-header">
                                <div className="Spark-Modal-header-left">
                                    <img src={SparkSvg} className="Spark-header" />
                                    <div className="Spark-Modal-header-title">
                                        <span className="Spark-Modal-header-title-text">
                                            {t("many_sparks")}
                                        </span>
                                        <span className="Spark-modal-header-subtitle">
                                            {t("available_balance")} {DailySparks}
                                        </span>
                                    </div>
                                    <div className="Spark-modal-header-right">
                                        <Button className="close-button" onClick={cancel}
                                            style={{ padding: "0", margin: "0", maxWidth: "30px", width: "30px", minWidth: "20px" }}>
                                            <span className="material-symbols-outlined">close</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="Send-Spark-modal-content">
                                <div className="Selected-user-card">
                                    <div className="Selected-user-info">
                                        <div className="Selected-user-head">
                                            <span className="user-spark-name">
                                                {selectedSparkReceiver.firstName} {selectedSparkReceiver.lastName}
                                            </span>
                                            <span className="change-selected-user"
                                                onClick={() => { returnToSelectReceiver() }}>
                                                {t("change")}
                                            </span>
                                        </div>
                                        <span className="Selected-user-room">
                                            {selectedSparkReceiver.room_label}
                                        </span>
                                    </div>

                                </div>
                                <div className="Select-Spark-Send">
                                    <div className="selected-spark-count-container">
                                        <span className="selected-spark-count">{selectedSparkCount}</span>
                                        <span className="selected-spark-label">{t("selected_sparks")}</span>
                                    </div>
                                    <div className="Select-Spark-Send-icon">
                                        {Array.from({ length: maxSparksToSend }).map((_, index) => {
                                            const isSelected = index < selectedSparkCount;
                                            return (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className={`spark-icon-button ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => handleSparkClick(index)}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {isSelected ? (
                                                        <img src={SparkSvg} alt="spark-used" className="spark-icon" />
                                                    ) : (
                                                        <img src={SparkNotUsed} alt="spark-available" className="spark-icon" />
                                                    )}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>

                                <textarea
                                    className="Spark-message-input"
                                    placeholder={t("add_message")}
                                    value={sparkMessage}
                                    onChange={(e) => setSparkMessage(e.target.value)}
                                    maxLength={200}
                                    rows={3}
                                    style={{
                                        borderRadius: ""
                                    }}
                                />
                            </div>
                            <div className="Spark-modal-button-container">
                                <button type="button" className="Spark-modal-button-cancel" onClick={() => { returnToSelectReceiver() }}>
                                    {t("back")}
                                </button>
                                <button type="button"
                                    className={selectedSparkCount > 0 ? 'Spark-modal-button-send-sparks' : 'Spark-modal-button'}
                                    onClick={() => { sendSparksToUser(); }}>
                                    {t("send_sparks")}
                                </button>
                            </div>
                        </>
                    }


                    {selectedModal === "SparkSent" &&
                        <>
                            <div className="Spark-Modal-header">
                                <div className="Spark-Modal-header-left">
                                    <span className="material-symbols-outlined Spark-person">
                                        check_circle
                                    </span>
                                    <div className="Spark-Modal-header-title">
                                        <span className="Spark-Modal-header-title-text">
                                            {t("spark_sent")}
                                        </span>
                                        <span className="Spark-modal-header-subtitle">
                                            {t("spark_notif")}
                                        </span>
                                    </div>
                                    <div className="Spark-modal-header-right">
                                        <Button className="close-button" onClick={cancel}
                                            style={{ padding: "0", margin: "0", maxWidth: "30px", width: "30px", minWidth: "20px" }}>
                                            <span className="material-symbols-outlined">close</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="Sent-spark-modal-content">
                                <div className="Send-info">
                                    <div className="Sender-info">
                                        <div className="Sender-initials">
                                            {getInitials(mySparkData?.firstName, mySparkData?.lastName)}
                                        </div>
                                        <span className="Sender-message"> {t("you")} </span>
                                    </div>
                                    <div className="Sent-sparks-info">
                                        <div className="Sent-spark-data">
                                            <img src={SparkSvg} alt="spark-used" className="spark-icon-after-send" />
                                            <span className="Sent-spark-count">{selectedSparkCount}</span>
                                        </div>
                                        <img src={SparkArrow} alt="spark-arrow-used" className="spark-arrow-icon-after-send" />
                                    </div>
                                    <div className="Sender-info">
                                        <div className="Receiver-initials">
                                            {getInitials(selectedSparkReceiver?.firstName, selectedSparkReceiver?.lastName)}
                                        </div>
                                        <span className="Sender-message"> {selectedSparkReceiver?.firstName}</span>
                                    </div>
                                </div>
                                {sparkMessage.trim() && (
                                    <span className="Sent-message">
                                        "{sparkMessage.trim()}"
                                    </span>
                                )}
                            </div>
                            <div className="Rest-Sparks">
                                <span className="normal-message-spark">{t("you_have")}</span>
                                <span className="green-message-spark"> {DailySparks}</span>
                                <span className="normal-message-spark"> {t("sparks_distribut")} </span>
                            </div>
                                {DailySparks > 0 && (
                            <div className="Spark-modal-button-container">
                                <button type="button" className="Spark-modal-button-send-sparks" style={{ width: "100%" }} onClick={() => { returnToSelectReceiver() }}>
                                    {t("dist_again")}
                                </button>
                            </div> )}
                        </>
                    }
                </div>
                </div>
          
        </>
    );
}